// @owners { team: patients-team }
import { type ReduxStateShared } from '~shared/types';

export const getCSATViewedDate = (state: ReduxStateShared) => state.csat.lastViewedDate;
